import { Toast } from 'antd-mobile'
import React from 'react'

// const loadingDefaultPic =  'https://cdn.shubox.com/ubox-fe/images/loading/loading_first_white.png'
// const loadingWhitePic = 'https://cdn.shubox.com/ubox-fe/images/loading/loading_gif_white.gif'

// 样式
import style from './Loading.module.scss'

let Loading: any


const LoadingContent = () => {
  // const [ picUrl, setPicUrl ] = useState(loadingDefaultPic)
  // useEffect(()=>{
  //   // 加载成功后替换成gif地址
  //   const _pic = new Image()
  //   _pic.src = loadingWhitePic
  //   _pic.onload = () => {
  //     setPicUrl(loadingWhitePic)
  //   }
  // }, [])
  return <>
      <svg viewBox="0 0 50 50" className={style.loadingSvg}>
      <circle cx="25" cy="25" r="20" fill="none" className={style.path}></circle>
      </svg>
    </>
}

const LoadingShow = (props: any)=> {
  Toast.config({ duration: 0 })
  // 关闭所有toast
  Toast.clear()
  Loading = Toast.show({
    maskClassName: style.loading,
    maskClickable: false,
    icon: <LoadingContent></LoadingContent>,
    ...props,
  })
}

const LoadingClose = ()=> {
  Loading.close()
  Toast.config({ duration: 2000 })
}

export default {
  show: LoadingShow,
  close: LoadingClose,
}
